import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageInstance } from "../../utils/localStorage";
import { currentUserId, currentUserToken } from "../../utils/constants";

const Private = () => {
  const location = useLocation();
  
  const currentUrl = `${location.pathname}${location.search}`;
  const token =
    currentUserToken();

  const userId = currentUserId();
  const auth = token && userId;

  localStorageInstance.setItem({ key: "redirectLocation", value: currentUrl });
  return auth ? <Outlet /> : <Navigate to="/" />;
};

export default Private;
